import { useQuery } from '@apollo/client/react';
import { Input, Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Spacer } from '../../components/Spacer';
import { ADMIN_USERS } from '../../gqls/users';

const TAKE = 50;

export const PageUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filterPhone, setFilterPhone] = useState('');
  const [filterName, setFilterName] = useState('');

  const { data, loading } = useQuery(ADMIN_USERS, {
    variables: {
      where: {
        phone: filterPhone || undefined,
        name: filterName || undefined,
      },
      take: TAKE,
      skip: (currentPage - 1) * TAKE,
    },
  });
  const adminUsers = data?.adminUsers || [];
  const adminUsersCount = data?.adminUsersCount || 0;

  return (
    <>
      <Typography.Title level={5} style={{ margin: 0 }}>
        Пользователи ({adminUsersCount})
      </Typography.Title>
      <Spacer h={12} />
      <ContentTable>
        <Filter>
          <Input.Search
            allowClear
            onSearch={(v) => setFilterPhone(v)}
            placeholder="Номер телефона"
            style={{ width: 200 }}
          />
          <Spacer w={16} />
          <Input.Search
            allowClear
            onSearch={(v) => setFilterName(v)}
            placeholder="Имя пользователя"
            style={{ width: 200 }}
          />
        </Filter>
        <Spacer h={12} />
        <Table
          size="middle"
          loading={loading}
          dataSource={adminUsers}
          columns={[
            {
              key: 'id',
              dataIndex: 'id',
              title: 'ID',
              render: (id) => <Link to={`/users/${id}`}>{id.slice(0, 8)}...</Link>,
            },
            {
              key: 'name',
              dataIndex: 'name',
              title: 'Имя',
              render: (name) => name || '',
            },
            {
              key: 'phone',
              dataIndex: 'phone',
              title: 'Телефон',
            },
            {
              key: 'blocked',
              dataIndex: 'blocked',
              title: 'Статус',
              render: (blocked) => (blocked ? <Tag color="red">Заблокирован</Tag> : <Tag color="green">Активен</Tag>),
            },
            {
              key: 'createdAt',
              dataIndex: 'createdAt',
              title: 'Создан',
              render: (date) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
          ]}
          pagination={{
            current: currentPage,
            total: adminUsersCount,
            pageSize: TAKE,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </ContentTable>
    </>
  );
};

const ContentTable = styled.div`
  overflow-x: auto;

  table {
    min-width: 1100px;
  }
`;

const Filter = styled.div`
  display: flex;
  flex-direction: row;
`;
